import React, { useState, useLayoutEffect, useRef } from "react";
import { ResponsiveContainer } from "recharts";

export function ChartContainer({ height, children, className }) {
  const containerRef = useRef(null);
  const [isMeasured, setIsMeasured] = useState(false);

  useLayoutEffect(() => {
    if (!containerRef.current) return;

    const checkSize = () => {
      if (containerRef.current && containerRef.current.clientWidth > 0) {
        setIsMeasured(true);
      }
    };

    // Initial check
    checkSize();

    // Since Recharts uses ResizeObserver internally on the ResponsiveContainer,
    // we only need to ensure the container itself is measured before mounting it.
    // If it mounts with width 0, Recharts complains.
    const observer = new ResizeObserver(() => checkSize());
    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        width: "100%",
        height: height,
        minWidth: 0,
        overflow: "hidden",
      }}
    >
      {isMeasured && (
        <ResponsiveContainer width="100%" height="100%">
          {children}
        </ResponsiveContainer>
      )}
    </div>
  );
}
